export enum ConnectionEffectiveType {
  slow2G = 'slow-2g',
  twoG = '2g',
  threeG = '3g',
  fourG = '4g'
}
